/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { parse as parseQuery } from 'query-string';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import { useMenu } from '../../contexts/SiteContext';
import Blocks from '../blocks/Blocks';
import Header from '../headers/Header';
import DeletedAccount from '../notifications/DeletedAccount';

import styles from '../../../styles/pages/home.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const HomePage = ({ page, className }) => {
    const { search = null } = useLocation();
    const { deleted = null } = parseQuery(search);
    const { slides = [], description = null, blocks = null } = page || {};
    const hasDeletedNotification = deleted !== null;
    const [showNotification, setShowNotification] = useState(hasDeletedNotification);
    const { showMenu } = useMenu();

    useEffect(() => {
        if (hasDeletedNotification) {
            setTimeout(() => {
                setShowNotification(false);
            }, 10000);
        }
    }, [hasDeletedNotification]);

    const onAnimationComplete = useCallback(() => {
        showMenu();
    }, [showMenu]);

    useScrollToTop(page);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Header
                description={description}
                slides={slides}
                type="carousel"
                onComplete={onAnimationComplete}
            />
            {hasDeletedNotification && showNotification ? (
                <DeletedAccount className={styles.notification} />
            ) : null}
            {blocks !== null && blocks.length > 0 ? (
                <div className={styles.section}>
                    <Blocks blocks={blocks} />
                </div>
            ) : null}
        </div>
    );
};

HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

export default HomePage;
